module.exports = __webpack_public_path__ + "static/rewards-card-lancer-jd-315ef70de0e0abe7632daded7b13fb4c.png";